import { ConfigProvider } from 'antd'
import locale_EN from 'antd/lib/locale/en_US';
import locale_IR from 'antd/lib/locale/fa_IR';
import Routers from '../../routers';
import React, { useEffect, useState } from 'react';
import {ToastContainer} from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
const lang = localStorage.getItem("lang")
function App() {
  useEffect(() => {
    if (!lang) localStorage.setItem("lang", "en")
  }, [])
 
  return (
    <ConfigProvider direction={(!lang || (lang === 'en')) ? 'ltr' : 'rtl'} locale={(!lang || (lang === 'en')) ? locale_EN : locale_IR} >
      <Routers />
      <ToastContainer toastStyle={{ direction: !lang || lang === "en" ? "ltr" : "rtl" }} autoClose={5000} position="top-center"/>
    </ConfigProvider >
  );
}

export default App;
